module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-BoldItalic-fee95791be263a37dbb0ca3ec158adbf.woff2";